import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';

export default function SimulationRadioButton(props) {
  const {
    selected,
    children,
    ...rest
  } = props || {};
  return (
    <FocusableButton {...ex(['SimulationRadioButton', { selected }], props)}>
      <VBox>
        {children}
      </VBox>
    </FocusableButton>
  );
}
